<template lang="html">
  <a href="https://odenserundt.dk/indsend" target="_blank" aria-label="Indsend nyt brugerønske">
    <div class="userwish-btn blue-text" style="float: right; margin-top: 5px;">
      <img src="/img/customUseIcons/wish.svg" height="30" width="30" style="margin-left: 5px;" aria-hidden="true"/>
      <br>
      <strong>Indsend ønske</strong>
    </div>
  </a>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  .userwish-btn {
    width: 20%;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
  }
</style>
